<template>
  <div class="need" @click.self="$emit('close')">
    <div class="panel">
      <h2>{{ t('needDeck.title') }}</h2>
      <p>{{ t('needDeck.body') }}</p>
      <div class="row">
        <router-link to="/packs" class="cta" @click="$emit('close')">
          {{ t('needDeck.toPacks') }}
        </router-link>
        <router-link to="/deck-builder" class="ghost" @click="$emit('close')">
          {{ t('needDeck.deckBuilder') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '../i18n/t'

defineEmits<{ close: [] }>()
const { t } = useI18n()
</script>

<style scoped>
.need {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: max(16px, env(safe-area-inset-top))
    max(16px, env(safe-area-inset-right))
    max(16px, env(safe-area-inset-bottom))
    max(16px, env(safe-area-inset-left));
  background: var(--md-scrim);
}

.panel {
  width: min(440px, 100%);
  max-height: 100%;
  overflow-y: auto;
  padding: 28px;
  border-radius: 12px;
  background: var(--md-sys-color-surface-container);
  border: 1px solid color-mix(in srgb, var(--md-sys-color-primary) 35%, transparent);
  color: var(--md-sys-color-on-surface);
  text-align: center;
}

h2 {
  color: var(--md-sys-color-on-surface);
  margin-bottom: 10px;
}

p {
  color: var(--md-sys-color-on-surface-variant);
  margin-bottom: 20px;
  line-height: 1.5;
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.cta,
.ghost {
  padding: 10px 16px;
  border-radius: 8px;
  font-weight: 700;
  min-height: 44px;
  display: inline-flex;
  align-items: center;
}

.cta {
  background: var(--md-sys-color-primary);
  color: var(--md-sys-color-on-primary);
}

.ghost {
  border: 1px solid var(--md-sys-color-outline);
  color: var(--md-sys-color-on-surface);
}

@media (max-height: 500px) and (max-width: 1100px) {
  .panel {
    padding: 16px 18px;
  }
}
</style>
